import {FC, useEffect, useState} from "react";

import { Box } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import { FullWidthVStack } from "@components/common";
import EmailInput from "@components/EmailInput";
import PhoneInput from "@components/PhoneInput";
import TextInput from "@components/TextInput";
import { useRouter } from "@lib/router";
import { DOMAIN } from "@utils/constants";

import { ORDER_FIELDS_MAX_LENGTHS, OrderFields } from "../../constants";
import useOrderFormik from "../../hooks/useOrderFormik";
import SectionTitle from "../common/SectionTitle";
import SenderPhoneNotificationMessage from "../common/SenderPhoneNotificationMessage";
import { findCountryCode } from "@components/PhoneInput/utils/findCountryCode";

const SenderInfo: FC = () => {
  const { t } = useTranslation();

  const { values } = useOrderFormik();

  const { defaultLocale } = useRouter();

  const [ phoneCountryCode, setPhoneCountryCode ] = useState<string | null | undefined>(null);

  useEffect(() => {
    const phoneNumber = values[OrderFields.SENDER_PHONE_NUMBER];
    const phoneNumberCode = phoneNumber ? findCountryCode(phoneNumber) : null;
    if (phoneNumberCode) {
      setPhoneCountryCode(phoneNumberCode);
    }
  }, [values[OrderFields.SENDER_PHONE_NUMBER]])

  return (
    <FullWidthVStack spacing="1rem">
      <SectionTitle>{t("order-sender-sender")}</SectionTitle>
      <FullWidthVStack spacing="1rem">
        <Box data-field={OrderFields.SENDER_NAME}>
          <TextInput
            name={OrderFields.SENDER_NAME}
            label={`${t("order-sender-sender_name")}`}
            id="order-sender-name"
            maxLength={ORDER_FIELDS_MAX_LENGTHS.name}
          />
        </Box>
        <Box data-field={OrderFields.SENDER_PHONE_NUMBER}>
          <PhoneInput
            name={OrderFields.SENDER_PHONE_NUMBER}
            label={t("order-sender-sender_mobile_number")}
            id="order-sender-phone"
            onPhoneCodeChange={setPhoneCountryCode}
            pinnedPhoneCodes={DOMAIN.DOMAIN_PHONE_NUMBERS[defaultLocale!]}
            defaultCountry={values[OrderFields.STARTING_COUNTRY]!}
          />
        </Box>
        <SenderPhoneNotificationMessage phoneCountryCode={phoneCountryCode} />
        <Box data-field={OrderFields.SENDER_EMAIL}>
          <EmailInput
            name={OrderFields.SENDER_EMAIL}
            label={t("order-sender-sender_email")}
            id="order-sender-email"
            maxLength={ORDER_FIELDS_MAX_LENGTHS.email}
          />
        </Box>
      </FullWidthVStack>
    </FullWidthVStack>
  );
};
export default SenderInfo;
